import type { InputHTMLAttributes } from "react";

type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  /**
   * Optional. Prefer wrapping in <FormRow> instead, which handles the label
   * plus helper and error text. Passing `label` here renders a bare label and
   * will double up if it is also inside a FormRow.
   */
  label?: string;
};

export function Field({ label, id, className, ...props }: FieldProps) {
  const fieldId = id ?? (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);
  const input = (
    <input className={["field", className].filter(Boolean).join(" ")} id={fieldId} {...props} />
  );
  if (!label) return input;
  return (
    <div className="form-row">
      <label className="field-label" htmlFor={fieldId}>{label}</label>
      {input}
    </div>
  );
}
